export const AGENT_TARGETS_MAX_AGE_MS = 60_000;
export const LOCAL_TARGETS_MAX_AGE_MS = 15_000;
export const FORCE_REFETCH_MAX_AGE_MS = 0;
